import { client } from "./client";

export interface ChartSupporting {
  id: number;
  data: string;
  created_at: string;
  updated_at: string;
}

export function apiGetChartSupportings(chartId: number) {
  return client.get(`/charts/${chartId}/chart_supportings`);
}

export function apiCreateChartSupporting(chartId: number, data: string) {
  return client.post(`/charts/${chartId}/chart_supportings`, { data });
}

export function apiUpdateChartSupporting(
  chartId: number,
  supportingId: number,
  data: string
) {
  return client.put(
    `/charts/${chartId}/chart_supportings/${supportingId}`,
    { data }
  );
}

export function apiDeleteChartSupporting(chartId: number, supportingId: number) {
  return client.delete(
    `/charts/${chartId}/chart_supportings/${supportingId}`
  );
}

